import { GET_BusinessCategory_SUCCESS, GET_BusinessCategory_LOADING, GET_BusinessCategory_FAILD, GET_BusinessCategory_RESET } from "../types";

const initialState = {
  loading: false,
  error: null,
  BusinessCategoryList: null,
};

export const getListOfBusinessCategory = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_BusinessCategory_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_BusinessCategory_SUCCESS:
      return {
        ...state,
        loading: false,
        BusinessCategoryList: action.payload,
        error: null,
      };
    case GET_BusinessCategory_FAILD:
      return {
        ...state,
        loading: false,
        currencyList: null,
        error: action.error,
      };
    case GET_BusinessCategory_RESET:
      return initialState;
    default:
      return state;
  }
};
